export const productCarouselStyles = {
    '.einsteinRecommendations': {
        paddingBottom: {base: '48px', sm: '64px'},
        '.product-tile-block': {
            padding: {base: '8px', md: '8px 8px 0', lg: '8px 12px 0'},
            backgroundColor: '#fff',
            borderRadius: '8px'
        },
        '.wishlistButton': {
            position: 'absolute',
            right: '8px',
            top: '8px'
        },
        '.slick-track': {
            display: 'flex',
            padding: '2px'
        },
        '.slick-arrow': {
            top: '0'
        },
        '.slick-slide': {
            marginRight: '16px'
        },
        '.slick-arrow.slick-disabled': {
            opacity: '0.5'
        },
        '.arrow': {
            position: 'absolute'
        },
        '.recommenderHeading': {
            textAlign: 'left',
            color: 'black',
            fontSize: {base: '2xl', md: '40px'},
            fontWeight: 'extrabold',
            lineHeight: {base: '8', md: '52px'},
            mb: {base: 4, sm: 8},
            mt: {base: 4, sm: 8},
            height: {base: 'auto', sm: '32px', lg: '52px'}
        },
        '.recently-viewed-block': {
            padding: '0',
            margin: '0 10px',
            backgroundColor: 'white',
            borderRadius: '8px'
        },
        '.product-carousel-content-slot': {
            mb: '6'
        },
        '.carousel-arrows-pos .slick-arrow': {
            top: {base: '0', md: '10px'}
        }
    }
}
